import React, { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import axios from 'axios';
import ErrorWindow from './../../components/ErrorWindow/ErrorWindow.js'
import './Produkt.css';
import {
    useParams
} from "react-router-dom";
import MenuTop from '../../components/MenuTop/MenuTop.js';
import { getProducentStorage } from '../../dao/DAO.js';
import InfoWindow from '../../components/InfoWindow/InfoWindow.js';
import ProduktSklepy from './ProduktSklepy.js';
import KatalogiDialog from './Katalogi/KatalogiDialog.js';
const DAO_PRODUKT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/produkt';
const DAO_UPLOAD_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/upload';
export default function Produkt() {
    const [listaSklepow, setListaSklepow] = useState([]);
    const [errorInfoProduktSklepy, setErrorInfoProduktSklepy] = useState("");
    const [tabid, setTabid] = useState('producent');
    const [tabidproducent, setTabidproducent] = useState('opis');
    const [produkt, setProdukt] = useState({ id_produkt: "0" });
    const [imageLogoP, setImageLogoP] = useState(produkt.logo_url);
    const [imageZdjecieP, setImageZdjecieP] = useState(produkt.zdjecie_url);
    const [selectedFileLogoP, setSelectedFileLogoP] = useState(null);
    const [selectedFileZdjecieP, setSelectedFileZdjecieP] = useState(null);
    let { idprodukt } = useParams();
    const producent = getProducentStorage();
    console.log("tabid:" + tabid + " tabidproducent:" + tabidproducent);
    let biRefInfoWindow = {
    };
    let biRefErrorWindow = {
    };
    // const [idprodukt, setIdprodukt] = useState(idprodukt);
    const fetchProdukt = async () => {
        console.log("idprodukt: " + idprodukt);
        if (tabid === "gs1polska" || tabidproducent === "loga") {
            return false;
        }
        if (idprodukt === "0")
            return false;
        const res = await axios(DAO_PRODUKT_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "produkt", id_produkt: idprodukt }
        }).then((response) => {
            console.log("fetchProdukt response:" + JSON.stringify(response.data));
            if (typeof (response.data.error) != 'undefined') {
                console.log("show errorssss33" + JSON.stringify(response.data.error));
                return null;
            }
            return response.data.produkt;
        }).catch(err => console.log(err.message));
        if (res == null) {
            setProdukt(null);
        } else {
            setImageLogoP(res.logo_url);
            setImageZdjecieP(res.zdjecie_url);
            setProdukt(res);
        }
    };
    useEffect(() => {
        fetchProdukt();
    }, produkt);

    if (produkt === null) {
        return (
            <Container fluid>
                <Row>
                    <Col>
                        <MenuTop />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>brak produktu</p>
                    </Col>
                </Row>
            </Container>
        );
    }
    return (
        <Container fluid className="p-0">
            <Row className="menu-top shadow-sm">
                <Col className="mt-2 mb-2">
                    <MenuTop />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Image className="img-logop_tytul" src={produkt.logo_url} /> Nazwa: <strong>{produkt.nazwa}</strong>, ean: <strong>{produkt.ean}</strong>, nr kat.: <strong>{produkt.nr_katalogowy}</strong>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ProduktTabs />
                </Col>
            </Row>
            <ErrorWindow biRef={biRefErrorWindow} />
            <InfoWindow biRef={biRefInfoWindow} />
        </Container>
    );
    function zmianaGlownegoTaba(tabid) {
        console.log("zmianaGlownegoTaba: " + tabid);
        if (tabid === "produktsklepy") {
            ListaSklepow();
        }
        setTabid(tabid);
    }
    function ListaSklepow() {
        setErrorInfoProduktSklepy("");
        const fetchListaSklepow = async () => {

            if (produkt.id_produkt === "0")
                return false;
            const res = await axios(DAO_PRODUKT_URL, {
                method: 'POST',
                withCredentials: false,
                headers: {
                    'Accept': 'application/json'
                },
                data: { operacja: "produkt_sklepy", id_produkt: produkt.id_produkt }
            }).then((response) => {
                console.log("fetchListaSklepow response:" + JSON.stringify(response.data));
                if (typeof (response.data.error) != 'undefined') {
                    console.log("show " + JSON.stringify(response.data.error));
                    setErrorInfoProduktSklepy(response.data.error.info);
                    return null;
                }
                return response.data.sklepy;
            }).catch(err => console.log(err.message));
            if (res == null) {
                setListaSklepow(null);
            } else {
                setListaSklepow(res);
            }
        };
        fetchListaSklepow();

    }
    function ProduktTabs() {
        return (
            <Tab.Container activeKey={tabid} onSelect={(k) => zmianaGlownegoTaba(k)}>
                <Nav className="nav nav-tabs ml-3 nav-pills flex-column flex-sm-row text-center rounded-nav mt-2 tab-produkty">
                    <Nav.Item className="nav-item flex-sm-fill">
                        <Nav.Link className="nav-link text-uppercase font-weight-bold" eventKey="producent" title="Produkt">Produkt</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item flex-sm-fill">
                        <Nav.Link className="nav-link text-uppercase font-weight-bold" eventKey="produktsklepy" title="Sklepy">Sklepy</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="producent">
                        <ProduktProducent />
                    </Tab.Pane>
                    <Tab.Pane eventKey="produktsklepy">
                        <ProduktSklepy errorInfoProduktSklepy={errorInfoProduktSklepy} listaSklepow={listaSklepow} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="gs1polska">
                        <GS1Polska />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        );
    }
    function zmianaProducentaTaba(tabidproducent) {
        console.log("zmianaProducentaTaba" + tabidproducent);
        setTabidproducent(tabidproducent);
    }
    function ProduktProducent() {
        return (
            <Tab.Container activeKey={tabidproducent} onSelect={(k) => zmianaProducentaTaba(k)}>
                <Nav className="nav nav-tabs ml-3 nav-pills flex-column flex-sm-row text-center rounded-nav mt-2 tab-produkty justify-content-md-center border-0">
                    <Nav.Item className="nav-item flex-fill col-xl-4">
                        <Nav.Link className="text-uppercase font-weight-bold" eventKey="opis" title="Produkt">Opis</Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item flex-fill col-xl-4">
                        <Nav.Link className="text-uppercase font-weight-bold" eventKey="loga" title="Loga">Media</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="opis">
                        <ProduktProducentOpis />
                    </Tab.Pane>
                    <Tab.Pane eventKey="loga">
                        <ProduktProducentLoga />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>

        );
    }
    function GS1Polska() {
        if (produkt === null || produkt.id_produkt === "0") {
            return (<><h5 className="text-center mt-2">Zapisz nowy produkt</h5></>);
        }
        return (

            <Container >
                <a target="_blank" href={"https://www.eprodukty.gs1.pl/catalog/0" + produkt.ean}><h5 className="m-0 p-0">GS1 Polska</h5></a>
            </Container>

        );
    }

    function ProduktProducentOpis() {
        console.log("produkt.dane_json=" + produkt.dane_json);
        if (!produkt.dane_json) {
            produkt.dane_json = "{}";
        }
        let dane_json = JSON.parse(produkt.dane_json === "" ? "{}" : produkt.dane_json);
        if (!dane_json.www)
            dane_json.www = "";
        const nowy_nip = useRef(null);
        const nazwa = useRef(null);
        const marka = useRef(null);
        const ean = useRef(null);
        const nr_katalogowy = useRef(null);
        const www = useRef(null);
        const kategoria_gpc = useRef(null);
        const opis_krotki = useRef(null);
        const opis_dlugi = useRef(null);
        const dostepny = useRef(false);
        const handleSubmitZapisz = async e => {
            console.log("Zapisuje produkt");
            e.preventDefault();
            dane_json.www = www.current.value;
            let produkt_z = {
                nazwa: nazwa.current.value,
                marka: marka.current.value,
                ean: ean.current.value,
                dostepny: dostepny.current.checked,
                kategoria_gpc: kategoria_gpc.current.value,
                opis_krotki: opis_krotki.current.value,
                opis_dlugi: opis_dlugi.current.value,
                nr_katalogowy: nr_katalogowy.current.value,
                id_producent: produkt.id_producent,
                id_produkt: produkt.id_produkt,
                dane_json: dane_json
            };
            const zapiszProdukt = async () => {
                console.log({ operacja: "zapisz_produkt", id_produkt: produkt.id_produkt, produkt: produkt_z, nip: producent.nip });
                const res = await axios(DAO_PRODUKT_URL, {
                    method: 'POST',
                    withCredentials: false,
                    headers: {
                        'Accept': 'application/json'
                    },
                    data: { operacja: "zapisz_produkt", id_produkt: produkt.id_produkt, produkt: produkt_z, nip: producent.nip }
                }).then((response) => {
                    console.log("resp.daa ProduktProducentOpis:" + JSON.stringify(response));
                    if (typeof (response.data.error) != 'undefined') {
                        console.log("show errorssss33" + JSON.stringify(response.data.error));
                        biRefErrorWindow.pokazOkno(response.data.error.info);
                        return null;
                    }
                    console.log(biRefInfoWindow);
                    biRefInfoWindow.pokazOkno("Dane zapisano");
                    setProdukt(response.data.produkt);
                    return response.data.produkt;
                }).catch(err => console.log(err.message));
            };
            zapiszProdukt();
        }

        let classd = "";
        let checkform = (<Form.Check ref={dostepny} name="dostepny" label="Dostępny" value="f" defaultChecked id="dostepny" />);

        if (produkt.dostepny === "f") {
            classd = "bg-danger";
            checkform = (<Form.Check ref={dostepny} name="dostepny" label="Dostępny" value="t" id="dostepny" />);
        }
        const zmienProducentaClick = async e => {
            e.preventDefault();
            const r = window.confirm("Czy zmienić producenta?");
            if (r == true) {
                console.log("Nowy nip:" + nowy_nip.current.value);
                const zmienProducenta = async () => {
                    console.log({ operacja: "zmien_producenta", id_produkt: produkt.id_produkt, nip: nowy_nip.current.value });
                    const res = await axios(DAO_PRODUKT_URL, {
                        method: 'POST',
                        withCredentials: false,
                        headers: {
                            'Accept': 'application/json'
                        },
                        data: { operacja: "zmien_producenta", id_produkt: produkt.id_produkt, nip: nowy_nip.current.value }
                    }).then((response) => {
                        console.log("resp.daa zmienProducenta:" + JSON.stringify(response));
                        if (typeof (response.data.error) != 'undefined') {
                            console.log("show errorssss33" + JSON.stringify(response.data.error));
                            biRefErrorWindow.pokazOkno(response.data.error.info);
                            return null;
                        }

                        window.setTimeout(() => {
                            window.location = process.env.PUBLIC_URL + "/produktpododniu/" + produkt.id_produkt + "/" + nowy_nip.current.value;
                        }, 2000);
                        biRefInfoWindow.pokazOkno("Producenta zmieniony");
                    }).catch(err => console.log(err.message));
                };
                zmienProducenta();
            }
        }
        const elemenet = (

            <Container >
                <Row className={"justify-content-md-center mt-2 " + classd}>
                    <Col >
                        <Form className="produkt-formularz" >
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Id</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control mt-1" size="sm" type="text" placeholder="Small text" readOnly defaultValue={produkt.id_produkt} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Marka</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control mt-1" ref={marka} size="sm" type="text" placeholder="Wprowadź nazwę marki..." defaultValue={produkt.marka} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Nazwa</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control mt-1" ref={nazwa} size="sm" type="text" placeholder="Wprowadź nazwę produktu..." defaultValue={produkt.nazwa} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2"><a target="_blank" href={"https://www.eprodukty.gs1.pl/catalog/0" + produkt.ean}>Kod EAN</a></Form.Label>
                                <Col sm="4">
                                    <Form.Control className="formularz-control mt-1" ref={ean} size="sm" type="text" placeholder="Wprowadź kod EAN produktu..." defaultValue={produkt.ean} />
                                </Col>
                                <Col sm="6">
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="3">Nr katalogowy</Form.Label>
                                        <Col sm="9">
                                            <Form.Control className="formularz-control mt-1" ref={nr_katalogowy} size="sm" type="text" placeholder="Wprowadź numer katalogowy..." defaultValue={produkt.nr_katalogowy} />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Strona produktu</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control mt-1" ref={www} size="sm" type="text" placeholder="Wprowadź stronę produktu..." defaultValue={dane_json.www} />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Kategoria GPC</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control mt-1" ref={kategoria_gpc} size="sm" type="text" placeholder="Wprowadź kategorię GPC..." defaultValue={produkt.kategoria_gpc} />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Katalog</Form.Label>
                                <Col sm="10">
                                <KatalogiDialog id_produkt={produkt.id_produkt} /> 
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Opis krótki (250 znaków)</Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control" ref={opis_krotki} size="sm" as="textarea" rows={3} defaultValue={produkt.opis_krotki} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2">Opis długi </Form.Label>
                                <Col sm="10">
                                    <Form.Control className="formularz-control" size="sm" ref={opis_dlugi} as="textarea" rows={10} defaultValue={produkt.opis_dlugi} />
                                </Col>
                            </Form.Group>

                            <Form.Group controlId="formBasicCheckbox">
                                {checkform}
                                <Button variant="primary" type="submit" className="float-right" onClick={handleSubmitZapisz}>Zapisz</Button>
                            </Form.Group>

                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">

                                <Form.Label column sm="2">Zmień producenta </Form.Label>
                                <Col sm="2">
                                    <Form.Control className="formularz-control mt-1" ref={nowy_nip} size="sm" type="text" placeholder="nowy nip ..." />
                                </Col>
                                <Col sm="3">
                                    <Button variant="primary" type="submit" className="float-left" onClick={e =>
                                        zmienProducentaClick(e)
                                    }>Zmień producenta</Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
        if (produkt === null) {
            return (<>Brak</>);
        }
        return (elemenet);
    }


    function ProduktProducentLoga() {


        const [bladLogoP, setBladLogoP] = useState("");
        const [bladZdjecieP, setBladZdjecieP] = useState("");

        const fileChangedHandlerLogoP = e => {
            console.log("e.target.files[0].size" + e.target.files[0].size);
            setBladLogoP("");
            if (e.target.files[0].size > 300 * 1024) {
                setBladLogoP("Za duży rozmiar" + (e.target.files[0].size / 1024 / 1024).toFixed(1) + "Mb");
                console.log("za duży rozmiar");
                biRefErrorWindow.pokazOkno("Za duży rozmiar" + (e.target.files[0].size / 1024 / 1024).toFixed(1) + "Mb");
                return;
            }
            setSelectedFileLogoP(e.target.files[0]);
            setImageLogoP(URL.createObjectURL(e.target.files[0]));
        }

        const fileUploadHandlerLogoP = e => {
            console.log(selectedFileLogoP)
            const formData = new FormData()
            formData.append(
                'plik',
                selectedFileLogoP,
                selectedFileLogoP.name
            )
            formData.append('id_produkt', produkt.id_produkt);
            formData.append('operacja', "logop");
            console.log(formData);
            axios.post(DAO_UPLOAD_URL, formData, {
                onUploadProgress: progressEvent => {
                    console.log(progressEvent.loaded / progressEvent.total)
                }
            }).then(res => {
                if (typeof (res.data.error) != 'undefined') {
                    console.log("show errorssss33" + JSON.stringify(res.data.error));
                    biRefErrorWindow.pokazOkno(res.data.error.info);
                    return null;
                }
                console.log("resp.gs:" + JSON.stringify(res.data));
                console.log({ res });
                console.log(res.data.logo_url);
                setImageLogoP(res.data.logo_url);
                produkt.logo_url = res.data.logo_url;
                biRefInfoWindow.pokazOkno("Plik wysłano");
            }).catch(err => {
                console.error({ err });
            });
        }

        const fileChangedHandlerZdjecieP = e => {
            //let file_size = e.target.files[0].size;
            console.log("e.target.files[0].size" + e.target.files[0].size);
            setBladZdjecieP("");
            if (e.target.files[0].size > 500 * 1024) {
                setBladZdjecieP("Za duży rozmiar" + (e.target.files[0].size / 1024 / 1024).toFixed(1) + "Mb");
                console.log("za duży rozmiar");
                biRefErrorWindow.pokazOkno("Za duży rozmiar" + (e.target.files[0].size / 1024 / 1024).toFixed(1) + "Mb");
                return;
            }
            setSelectedFileZdjecieP(e.target.files[0]);
            console.log("xxxx:" + e.target.files[0]);
            setImageZdjecieP(URL.createObjectURL(e.target.files[0]));
            console.log("ssss:" + e.target.files[0]);

        }

        const fileUploadHandlerZdjecieP = e => {
            console.log("dddd:" + selectedFileZdjecieP);
            const formData = new FormData()
            formData.append(
                'plik',
                selectedFileZdjecieP,
                selectedFileZdjecieP.name
            )
            formData.append('id_produkt', produkt.id_produkt);
            formData.append('operacja', "zdjeciep");
            console.log(formData);
            axios.post(DAO_UPLOAD_URL, formData, {
                onUploadProgress: progressEvent => {
                    console.log(progressEvent.loaded / progressEvent.total)
                }
            }).then(res => {
                if (typeof (res.data.error) != 'undefined') {
                    console.log("show errorssss33" + JSON.stringify(res.data.error));
                    biRefErrorWindow.pokazOkno(res.data.error.info);
                    return null;
                }
                console.log("resp.gs:" + JSON.stringify(res.data));
                console.log({ res });
                console.log(res.data.zdjecie_url);
                setImageZdjecieP(res.data.zdjecie_url);
                biRefInfoWindow.pokazOkno("Plik wysłano");
            }).catch(err => {
                console.error({ err });
            });
        }


        if (produkt === null || produkt.id_produkt === "0") {
            return (<><h5 className="text-center mt-2">Zapisz nowy produkt</h5></>);
        }
        return (
            <Container className="mt-2">
                <Row>
                    <Col >
                        <h5>Logo produktu </h5>
                        <h6>Zalecany rozmiar 300x300(px) maks 300kb</h6>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <input className="input-przeslij" type="file" onChange={fileChangedHandlerLogoP} /><span>{bladLogoP}</span>
                        <button onClick={fileUploadHandlerLogoP}>Upload!</button>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <Image className="img-logop" src={imageLogoP} />
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <h5>Zdjecie produktu </h5>
                        <h6>Zalecany rozmiar 600x600(px) maks 0,5 MB</h6>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <input className="input-przeslij" type="file" onChange={fileChangedHandlerZdjecieP} /><span>{bladZdjecieP}</span>
                        <button onClick={fileUploadHandlerZdjecieP}>Upload!</button>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <Image className="img-zdjeciep" src={imageZdjecieP} />
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <hr />
                    </Col>
                </Row>

            </Container>
        );
    }
}
